import {colorSchemes} from '@nivo/colors';

export function isValidHexColor(color: string): boolean {
    const regex = /^#([0-9a-f]{3}){1,2}$/i;
    return regex.test(color);
}

const COLOR_SET = colorSchemes.set3;
export const getColor = (index: number): string => {
    return COLOR_SET[index % COLOR_SET.length];
};
